import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';

import { Billee } from '../model/billee';
import { BillingOptions } from '../model/billing-options';
import { PaymentDetails } from '../model/payment-details';
import { PaymentPlan } from '../model/payment-plan';

import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class BillingOptionsService {
  private billingOptions: BillingOptions;
  private readonly billingOptionsUrl = 'api/billingOptions';
  private paymentDetails: PaymentDetails;
  selectedBillee: Billee;
  selectedPaymentPlan: PaymentPlan;
  policyNumber: string;
  token = '';

  constructor(private route: ActivatedRoute,
              private http: HttpClient) {
    if (this.route.snapshot.queryParamMap.has('token')) {
      this.token = this.route.snapshot.queryParamMap.get('token');
    }
    this.paymentDetails = new PaymentDetails();
  }

  getBillingOptions(): Observable<BillingOptions> {
    if (this.billingOptions) {
      return of(this.billingOptions);
    }
    return this.http.get<BillingOptions>(this.billingOptionsUrl);
  }

  getPaymentDetails(): PaymentDetails {
    return this.paymentDetails;
  }

  getPolicyNumber(): string {
    return this.policyNumber;
  }

  getSelectedBillee(): Billee {
    return this.selectedBillee;
  }

  getSelectedPaymentPlan(): PaymentPlan {
    return this.selectedPaymentPlan;
  }

  getToken(): string {
    return this.token;
  }

  setBillingOptions(billingOptions: BillingOptions): void {
    if (!this.billingOptions) {
      this.billingOptions = billingOptions;
    }
  }

  setPaymentDetails(paymentDetails: PaymentDetails): void {
    this.paymentDetails = paymentDetails;
  }

  setSelectedBillee(billee: Billee): void {
    this.selectedBillee = billee;
  }

  setSelectedPaymentPlan(paymentPlan: PaymentPlan): void {
    this.selectedPaymentPlan = paymentPlan;
  }

  setPolicyNumber(policyNumber: string): void {
    this.policyNumber = policyNumber;
  }

}
